import FortniteLeaderboard from './FortniteLeaderboard';
export default FortniteLeaderboard;
